import * as React from 'react';
import { Tooltip } from '@cian/ui-kit';

import { INewbuildingPromo } from '../../types/newbuilding';
import { PROMO_ICONS_MAP } from './constants';

import * as styles from './PromoBlock.css';

interface IPromoBlockProps {
  onPromoClick?(promo: INewbuildingPromo): void;
  onPromoHover?(promo: INewbuildingPromo): void;
  promos: INewbuildingPromo[];
  url: string;
}

export const PromoBlock: React.FC<IPromoBlockProps> = ({ onPromoClick, onPromoHover, promos, url }) => {
  const displayPromos = React.useMemo(() => [...promos].reverse(), [promos]);

  const handleClickPromo = React.useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      if (onPromoClick) {
        const index = Number(event.currentTarget.getAttribute('data-index'));
        onPromoClick(displayPromos[index]);
      }
    },
    [onPromoClick, displayPromos],
  );

  const handleHoverPromo = React.useCallback(
    (index: number) => {
      if (onPromoHover) {
        onPromoHover(displayPromos[index]);
      }
    },
    [onPromoHover, displayPromos],
  );

  return (
    <div className={styles['container']}>
      {displayPromos.map((promo, idx) => (
        <Tooltip
          key={promo.promoType}
          title={promo.newbuildingLabel}
          placement="bottom-start"
          onOpen={() => handleHoverPromo(idx)}
        >
          <a
            className={styles['promo-link']}
            href={url}
            target="_blank"
            rel="noreferrer"
            data-index={idx}
            onClick={handleClickPromo}
          >
            <img className={styles['promo-icon']} src={PROMO_ICONS_MAP.get(promo.promoType)} />
          </a>
        </Tooltip>
      ))}
    </div>
  );
};
